import { ReactElement } from 'react';
import { Chip, makeStyles } from '@material-ui/core';
import { Theme, useTheme } from '@material-ui/core/styles';
import { SparklesIcon } from '../icons/sparkles-icon';

const useStyles = makeStyles<Theme>(theme => ({
  chip: {
    marginLeft: '.25em',
    marginBottom: '.25em',
    height: 'auto',
    padding: theme.spacing(0, 1.25),
    backgroundColor:
      theme.palette.type === 'dark' ? 'rgba(227, 245, 253, 0.16)' : '#E3F5FD',
    color:
      theme.palette.type === 'dark' ? '#B3DCF3' : theme.palette.text.primary,
  },
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontSize: '12px',
    fontWeight: 700,
    textTransform: 'none',
    color: 'inherit',
    padding: 0,
  },
}));

export const AutoRemediationBadge = (): ReactElement => {
  const classes = useStyles();
  const theme = useTheme<Theme>();
  const iconColor =
    theme.palette.type === 'dark' ? '#B3DCF3' : theme.palette.primary.dark;

  return (
    <Chip
      size="small"
      data-testid="auto-remediation-badge"
      role="status"
      aria-label="Auto remediation available"
      classes={{ root: classes.chip, label: classes.label }}
      label={
        <>
          <SparklesIcon color={iconColor} size={12} />
          Auto remediation
        </>
      }
    />
  );
};
